// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"c7fed672","52":"77cb76a2","119":"909e1128","159":"85f966a6","437":"68240a8e","452":"2620273f","487":"512541ed","540":"efb9e2bf","549":"90cfa640","560":"0daa200c","699":"2c15e8d3","728":"be09c123"}[chunkId] + ".chunk.js";
};